import { createSelector, createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { ProductInfoBlockComponent } from './product-info-block';
const totalAndRemainingSelector = (state, props) => ({
  totalQuantityInCart: props.totalQuantityInCart,
  remainingQuantityInCart: props.remainingQuantityInCart
});
const quantityInCartLabelSelector = createSelector(totalAndRemainingSelector, ({
  totalQuantityInCart
}) => {
  if (totalQuantityInCart === null) {
    return 'Remaining in cart:';
  }
  return 'Quantity in cart:';
});
const quantityInCartValueSelector = createSelector(totalAndRemainingSelector, ({
  totalQuantityInCart,
  remainingQuantityInCart
}) => {
  if (totalQuantityInCart === null) {
    return remainingQuantityInCart;
  }
  return totalQuantityInCart;
});
const mapStateToProps = createStructuredSelector({
  quantityInCartLabel: quantityInCartLabelSelector,
  quantityInCartValue: quantityInCartValueSelector
});
export const ProductInfoBlock = connect(mapStateToProps, {})(ProductInfoBlockComponent);